import { defineComponent as D, ref as u, onMounted as H, onBeforeUnmount as $, watch as _, withDirectives as g, createElementBlock as k, openBlock as b, renderSlot as I, createVNode as z, mergeProps as E, unref as B } from "vue";
import x from "./TessText.js";
import { a as F } from "./js.cookie-CA0diDCW.js";
import { D as v } from "./luxon-BFLqgYPH.js";
import { t as O } from "./tooltip-YeSRTnG0.js";
const R = { class: "tess-time-tag-wrapper" }, Z = "account.last_prefered_timezone", C = /* @__PURE__ */ D({
  __name: "TessTimeTag",
  props: {
    size: {},
    weight: {},
    width: {},
    tooltipTheme: {},
    showTooltip: { type: Boolean, default: !0 },
    format: { default: "MMM dd, yyyy | HH:mm:ss" },
    time: {},
    timezone: {}
  },
  setup(M) {
    const w = O, n = u(!0), e = M, T = (t) => {
      if (!t || t == null)
        return "";
      const r = new Date(t), a = (/* @__PURE__ */ new Date()).getTime() - r.getTime(), s = Math.floor(a / (1e3 * 60 * 60));
      let o = t;
      return s >= 12 ? (n.value = !1, o = l(t, "MMM dd, yyyy | HH:mm")) : (n.value = !0, p.value = v.fromISO(t).setZone(e.timezone).toFormat("MMM dd, yyyy | HH:mm"), o = h(t)), o;
    }, c = () => {
      switch (e.format) {
        case "MMM dd":
        case "MMM dd, yyyy":
          n.value = e.showTooltip && !0, i.value = l(e.time, e.format);
          break;
        case "MMM dd, yyyy | HH:mm:ss":
          i.value = l(e.time, e.format), n.value = e.showTooltip && !1;
          break;
        case "dynamic":
          i.value = T(e.time);
          break;
        case "rounding":
          i.value = h(e.time), n.value = e.showTooltip && !0;
          break;
        default:
          i.value = l(e.time, "MMM dd, yyyy | HH:mm"), n.value = e.showTooltip && !0;
          break;
      }
    }, i = u(""), p = u(""), l = (t, r) => {
      let m = t;
      try {
        const a = new Date(t).toISOString(), s = e.timezone || F.get(Z) || "Asia/Bangkok";
        m = v.fromISO(a).setZone(s).toFormat(r);
      } catch (a) {
        return console.error(a), t;
      }
      return m;
    }, h = (t) => {
      try {
        const r = new Date(t), a = Math.abs((/* @__PURE__ */ new Date()).getTime() - r.getTime()), s = Math.floor(a / (1e3 * 60)), o = Math.floor(s / 60), d = Math.floor(o / 24);
        if (d === 0) {
          if (o < 1)
            return `${s} minute${s === 1 ? "" : "s"} ago`;
          if (o <= 3) {
            const y = s % 60;
            return `${o} hour${o === 1 ? "" : "s"}${y > 0 ? ` ${y} minute${y === 1 ? "" : "s"}` : ""} ago`;
          }
          return `${o} hour${o === 1 ? "" : "s"} ago`;
        } else
          return `${d} day${d === 1 ? "" : "s"} ago`;
      } catch (r) {
        console.error("shortDate -> error", r);
      }
      return t;
    }, f = u(null);
    return H(() => {
      c(), f.value = setInterval(() => {
        c();
      }, 6e4);
    }), $(() => {
      f.value && clearInterval(f.value);
    }), _(
      () => e,
      () => {
        c();
      },
      { deep: !0, immediate: !0 }
    ), (t, r) => g((b(), k("div", R, [
      I(t.$slots, "default", {}, () => [
        z(x, E({ text: i.value }, e, { "show-tooltip": !1 }), null, 16, ["text"])
      ])
    ])), [
      [B(w), { content: M.showTooltip ? p.value : void 0, delay: [1e3, 0] }]
    ]);
  }
});
export {
  C as _
};
